/* Kröll Systeme · Bewertungsplatten-Shop · Verhalten der kc-* Sections.
   Einblenden beim Scrollen, der Kaufblock (Preis folgt der Menge) und die mobile Kaufleiste.
   Kein Tracking, kein Speicher auf dem Gerät. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.kc-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function buyForms() {
    document.querySelectorAll('[data-kc-buy]').forEach(function (form) {
      var priceOut = form.querySelector('[data-kc-price]');
      var btnPrice = form.querySelector('[data-kc-btn-price]');
      var opts = form.querySelectorAll('input[name="id"]');
      function sync() {
        var on = form.querySelector('input[name="id"]:checked');
        if (!on) return;
        var price = on.getAttribute('data-price');
        if (priceOut) priceOut.textContent = price;
        if (btnPrice) btnPrice.textContent = price;
        var sp = document.querySelector('[data-kc-sticky-price]');
        if (sp) sp.textContent = price;
      }
      opts.forEach(function (o) { o.addEventListener('change', sync); });
      sync();
    });
  }

  /* Mobile Kaufleiste: sichtbar, solange der Kaufknopf nicht im Bild ist. */
  function sticky() {
    var bar = document.querySelector('[data-kc-sticky]');
    var btn = document.querySelector('[data-kc-buy] button[type="submit"]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.hidden = e.isIntersecting;
      });
    }).observe(btn);
  }

  function init() { reveal(); buyForms(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
